import { PaymentSessionStatus } from '../../core/models/PaymentSessionStatus.enum';
import { HealerPackage } from '../../core/models/healer-package.dto';
import { extractMessageFromError } from '../../infra/adapters/luminara/common/ErrorUtil';

export interface PaymentState {
  paymentSessionStatus: PaymentSessionStatus;
  loadingDataErrors: string[];
  clientSecret?: string;
  healerPackage?: HealerPackage;
  paymentTimeExpired: boolean;
  paymentRemainingTime?: number;
  paymentTimerStarted: boolean;
}

export const initialPaymentState = () => {
  return {
    paymentSessionStatus: 'OPEN',
    loadingDataErrors: [],
    paymentTimeExpired: false,
    paymentTimerStarted: false,
  } as PaymentState;
};
export interface PaymentAction {
  type:
    | 'SET_PAYMENT_SESSION_CLIENT_SECRET'
    | 'SET_PAYMENT_SESSION_STATUS'
    | 'SET_PAYMENT_ERROR'
    | 'LOAD_HEALER_PACKAGE_SUCCESS'
    | 'LOAD_HEALER_PACKAGE_FAILURE'
    | 'PAYMENT_TIME_EXPIRED'
    | 'UPDATE_REMAINING_TIME_FOR_PAYMENT'
    | 'DEDUCE_ONE_SECOND_FROM_REMAINING_TIME'
    | 'START_PAYMENT_TIMER'
    | 'RESET';
  payload?: any;
}

const paymentReducer = (state: PaymentState = initialPaymentState(), action: PaymentAction): PaymentState => {
  switch (action.type) {
    case 'SET_PAYMENT_SESSION_CLIENT_SECRET': {
      return { ...state, clientSecret: action.payload };
    }
    case 'SET_PAYMENT_SESSION_STATUS': {
      return { ...state, paymentSessionStatus: action.payload };
    }
    case 'SET_PAYMENT_ERROR': {
      return { ...state, loadingDataErrors: state.loadingDataErrors.concat(extractMessageFromError(action.payload)) };
    }
    case 'LOAD_HEALER_PACKAGE_SUCCESS': {
      return { ...state, healerPackage: action.payload };
    }
    case 'LOAD_HEALER_PACKAGE_FAILURE': {
      return { ...state, loadingDataErrors: state.loadingDataErrors.concat(extractMessageFromError(action.payload)) };
    }
    case 'PAYMENT_TIME_EXPIRED': {
      return { ...state, paymentTimeExpired: true, paymentRemainingTime: 0 };
    }
    case 'UPDATE_REMAINING_TIME_FOR_PAYMENT': {
      return { ...state, paymentRemainingTime: action.payload, paymentTimeExpired: action.payload <= 0 };
    }
    case 'DEDUCE_ONE_SECOND_FROM_REMAINING_TIME': {
      return {
        ...state,
        paymentRemainingTime: state.paymentRemainingTime != null ? state.paymentRemainingTime - 1 : undefined,
        paymentTimeExpired: state.paymentRemainingTime != null && state.paymentRemainingTime - 1 <= 0,
      };
    }
    case 'START_PAYMENT_TIMER': {
      return { ...state, paymentTimerStarted: true };
    }
    case 'RESET': {
      return {
        paymentSessionStatus: 'OPEN',
        loadingDataErrors: [],
        paymentTimeExpired: false,
        healerPackage: undefined,
        clientSecret: undefined,
        paymentTimerStarted: false,
      };
    }
    default:
      return state;
  }
};

export default paymentReducer;
